import controller from '../../../../Scripts/Controller.js';
import Map from '../../../../Scripts/Common/GoogleMaps/Map.js';

function SchoolSearchMap(container) {

    const request = new XMLHttpRequest();

    function init() {

      var map = new Map(container);
      map.init();

      window.addEventListener('FilterUpdate', (e) => {

        //container.setAttribute('data-loading', 'true');

        request.abort();

        var searchParams = e.detail;
        var url = `${location.pathname}/updatemap?${searchParams.toString()}`;
        console.log(url);
        request.onreadystatechange = function() {
          if (this.readyState !== 4) return;
          if (this.status !== 200) {
            console.log(this);
            return;
          }
          var json = JSON.parse(this.responseText);

          if(json.length === 0) {
            document.querySelector('.schools__map-empty').classList.remove('hidden');
          }
          else {
            map.update(json);
            document.querySelector('.schools__map-empty').classList.add('hidden');
          }

        };
        request.open('POST', url, true);
        request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        request.send();
      })
    }
    return {
        init: init
    }
}

controller.add('SchoolSearchMap', SchoolSearchMap);

export default SchoolSearchMap;
